/**
 * WebGPU 相关常量定义
 * 用于存储硬编码字符串，遵循架构规范
 */

/**
 * WebGPU 缓存的 Symbol 键名
 * 用于在全局对象中缓存 WebGPU 设备和适配器
 */
export const WEBGPU_CACHE_KEY = 'webgpu_cache';